<template>
    <div>
        <vx-card title="MAP Revaluation">
            <div class="mt-3 ml-1 vx-row">
                <div class="mb-6 vx-row" style="width:70%">
                    <div class="flex items-center w-full vx-col sm:w-1/4">
                        <span>Warehouse</span>
                    </div>
                    <div class="w-full vx-col sm:w-3/4">
                        <multiselect
                            label="name"
                            track-by="name"
                            :disabled="false"
                            :options="(this.optionsData.length > 0) ? this.optionsData : []"
                            v-model="selectedWh" 
                            placeholder="type to search" 
                            :custom-label="label"
                        />
                    </div>
                </div>
                <div class="mb-6 vx-row" style="width:70%">
                    <div class="flex items-center w-full vx-col sm:w-1/4">
                    </div>
                    <div class="w-full vx-col sm:w-3/4">
                        <vs-button color="primary" @click="handleFilter()">Filter</vs-button>
                    </div>
                </div>
            </div>
            <div class="mt-3 vx-row">
                <div class="w-full vx-col mb-base">
                    <Table :draw="draw" :wh-code="(this.selectedWh) ? this.selectedWh.code : ''" :wh-id="(this.selectedWh) ? this.selectedWh.id : 0"></Table>
                </div>
            </div>
        </vx-card>
    </div>
</template>
<script>
import CustomMSelect from "../../inbound/receive/purchase-order/component/CustomMultiSelect.vue";
import Table from "./table.vue";
export default {
    components: {
        CustomMSelect,
        Table
    },
    data() {
        return {
            draw: 0,
            selectedWh: null,
            optionsData: [],
        }
    },
    methods: {        
        // handleCreate() {
        //     this.$vs.loading();
        //     this.$router.push({
        //         name: "map.revaluation.create",
        //     });
        // },
        handleFilter() {
            if (this.selectedWh) {
                this.draw++;
            } else {
                this.$vs.notify({
                    color: "danger",
                    title: "Validation",
                    position: "top-right",
                    text: "Please select Warehouse",
                    iconPack: "feather",
                    icon: "icon-x-circle"
                });
            }
        },
        getDataWarehouse() {
            this.$vs.loading();
            this.$http
            .get("/api/wms/v1/master/warehouses", {
                // params: {
                //     limit: 10,
                //     page: 1,
                //     query: "",
                //     order: "id",
                //     sort: "asc",
                // },
            })
            .then((resp) => {
                if (resp.code == 200) {
                    this.optionsData = resp.data.records;
                    this.$vs.loading.close();
                } else {
                    this.$vs.loading.close();
                }
            });
        },
        label({ code, name }) {
            return `${code} - ${name}`;
        },
    },
    mounted(){
        this.getDataWarehouse();
        // let a = {
        //     id: 0,
        //     code: "All",
        //     name: "All"
        // }

        // if (this.selectedPoType.length == 0) {
        //     this.selectedPoType = [a]
        // }
    },
    watch: {
        
    }
}
</script>

<style>

</style>